import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'lib-privacidade',
  standalone: true,
  imports: [RouterLink],
  styles: [`
    .privacidade-container {
      max-width: 860px;
      margin: 0 auto;
      padding: 2rem 1.5rem 4rem;
      color: var(--text-color, #cdd6f4);
      font-family: inherit;
      line-height: 1.75;
    }

    h1 {
      font-size: 1.875rem;
      font-weight: 700;
      margin-bottom: 0.5rem;
      color: var(--text-color, #cdd6f4);
    }

    .updated {
      font-size: 0.8rem;
      color: var(--text-color-secondary, #a6adc8);
      margin-bottom: 2.5rem;
    }

    h2 {
      font-size: 1.15rem;
      font-weight: 600;
      margin-top: 2rem;
      margin-bottom: 0.5rem;
      color: var(--primary-color, #89b4fa);
    }

    p, ul { margin-bottom: 1rem; }

    ul { padding-left: 1.5rem; }

    .back-link {
      display: inline-flex;
      align-items: center;
      gap: 0.375rem;
      margin-bottom: 2rem;
      color: var(--primary-color, #89b4fa);
      cursor: pointer;
      font-size: 0.875rem;
    }

    .back-link:hover { text-decoration: underline; }

    .highlight-box {
      background: var(--surface-card, #1e1e2e);
      border: 1px solid var(--surface-border, #313244);
      border-radius: 0.5rem;
      padding: 1rem 1.25rem;
      margin: 1rem 0;
      font-size: 0.875rem;
    }
  `],
  template: `
    <div class="privacidade-container">
      <a class="back-link" [routerLink]="['/']">← Voltar ao início</a>

      <h1>Política de Privacidade</h1>
      <p class="updated">Última atualização: Março de 2026</p>

      <p>
        Esta política descreve como o <strong>{{ systemName }}</strong> coleta, usa e protege
        as informações dos usuários, em conformidade com a
        <strong>Lei Geral de Proteção de Dados (LGPD — Lei nº 13.709/2018)</strong>.
      </p>

      <h2>1. Dados Coletados</h2>
      <p>Coletamos apenas os dados necessários para a operação do sistema:</p>
      <ul>
        <li><strong>Dados de conta:</strong> nome, e-mail e informações de cadastro fornecidas por você.</li>
        <li><strong>Dados de uso:</strong> páginas acessadas, ações realizadas e preferências de navegação.</li>
        <li><strong>Dados técnicos:</strong> tipo de dispositivo, navegador, sistema operacional e endereço IP (anonimizado).</li>
      </ul>

      <h2>2. Microsoft Clarity — Análise de Comportamento</h2>
      <div class="highlight-box">
        Utilizamos o <strong>Microsoft Clarity</strong>, uma ferramenta de análise de comportamento de usuário
        que registra mapas de calor (heatmaps) e sessões de navegação de forma anônima.
        <br /><br />
        <strong>O que o Clarity coleta:</strong>
        <ul style="margin-top: 0.5rem;">
          <li>Cliques, rolagem e movimentos do mouse</li>
          <li>Gravações de sessão (sem capturar senhas ou dados sensíveis)</li>
          <li>Dispositivo, navegador e resolução de tela</li>
        </ul>
        <br />
        O Clarity <strong>não coleta</strong> dados pessoais identificáveis (como nome ou e-mail).
        Dados sensíveis exibidos na tela são automaticamente mascarados.
        <br /><br />
        Para saber mais, consulte a
        <a href="https://privacy.microsoft.com/pt-br/privacystatement" target="_blank" rel="noopener">
          Política de Privacidade da Microsoft
        </a>.
      </div>

      <h2>3. Base Legal (LGPD)</h2>
      <p>
        O uso de ferramentas analíticas como o Clarity está baseado no seu <strong>consentimento expresso</strong>
        (Art. 7º, inciso I da LGPD). Você pode revogar o consentimento a qualquer momento limpando os dados
        do navegador ou entrando em contato conosco.
      </p>

      <h2>4. Compartilhamento de Dados</h2>
      <p>
        Não vendemos nem cedemos seus dados a terceiros. Os dados analíticos são processados exclusivamente
        pela Microsoft (Clarity) para fins de melhoria da experiência do usuário.
      </p>

      <h2>5. Segurança</h2>
      <p>
        Adotamos medidas técnicas e organizacionais para proteger seus dados contra acesso não autorizado,
        perda ou divulgação indevida.
      </p>

      <h2>6. Seus Direitos (LGPD)</h2>
      <p>De acordo com a LGPD, você tem direito a:</p>
      <ul>
        <li>Confirmar a existência de tratamento de dados</li>
        <li>Acessar seus dados pessoais</li>
        <li>Solicitar a correção ou exclusão dos dados</li>
        <li>Revogar o consentimento a qualquer momento</li>
      </ul>

      <h2>7. Contato</h2>
      <p>
        Para exercer seus direitos ou tirar dúvidas sobre esta política, entre em contato:
        <br />
        <strong>E-mail:</strong> privacidade&#64;nomoh.com.br
      </p>
    </div>
  `,
})
export class PrivacidadeComponent {
  @Input() systemName = 'Nomoh';
}
